import React from 'react';
import bgimg from '../../images/contact-bg.jpg'
import ContactFormSection from '../../components/ContactFormSection/ContactFormSection'
const ConsultaFormSection = (props) => {
    return (
        <section className={"" + props.hclass}>
            <div className="wraper" style={{ backgroundImage: `url(${bgimg})`}}>
                <div className="contact">
                    <h2>Get A Free Consultation</h2>
                    <ContactFormSection/>
                </div>
            </div>
        </section>
    );
};

export default ConsultaFormSection;